import React from "react";
import { useTranslation } from "react-i18next";
import { MessageSquare, Loader2 } from "lucide-react";

export default function ChatHistoryEmptyState({ isLoading }) {
    const { t } = useTranslation();

    if (isLoading) {
        return (
            <div className="h-full flex flex-col items-center justify-center text-gray-500">
                <Loader2 className="w-5 h-5 animate-spin mb-2" />
                <p className="text-sm">{t("common.loading")}</p>
            </div>
        );
    }

    return (
        <div className="h-full flex flex-col items-center justify-center px-6 py-12 text-center">
            <div className="w-14 h-14 mx-auto mb-4 rounded-full bg-gradient-to-br from-blue-50 to-indigo-50 flex items-center justify-center">
                <MessageSquare className="w-6 h-6 text-blue-500" />
            </div>
            <p className="text-base font-medium text-gray-900">
                {t("chatTwoColumnPage.pastConversationsEmptyTitle")}
            </p>
            <p className="text-sm text-gray-500 mt-1.5 max-w-xs">
                {t("chatTwoColumnPage.pastConversationsEmptyBody")}
            </p>
        </div>
    );
}
